import { useGetCard } from '@vlabs/api/artemy/client';
import { useCardIdFromLocationPoint3 } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { useHasPermission } from '@vlabs/permissions';
import { parseISOToLocale } from '@vlabs/shared/utils/date';
import { CopyButton, Tooltip } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './CardGeneralInfo.module.sass';
import { EditCardUserDataButton } from '../edit-card-user-data';
import type { TPointCard } from '../types';

const displayName = 'CardGeneralInfo';
const testid = buildTestid(displayName);

export function CardGeneralInfo(): JSX.Element {
  const cardId = useCardIdFromLocationPoint3();
  const { t } = useTranslation();
  const getCard = useGetCard<TPointCard>(cardId);
  const canUpdateCard = useHasPermission('card', 'update');
  const createdAt = getCard.data?.create_time
    ? (parseISOToLocale(getCard.data.create_time) ?? '-')
    : '-';

  return (
    <div
      className={st.Info}
      {...testid()}
    >
      <header className={st.InfoHeader}>
        <span>{t('card-page:info block.title')}</span>
        {!!canUpdateCard && <EditCardUserDataButton cardId={cardId} />}
      </header>
      <div className={st.InfoBody}>
        <div className={st.Row}>
          <span className={st.Label}>
            {t('card-page:info block.fio')}
          </span>
          <span className={st.Value}>
            {getCard.data?.user_data?.fio ?? '-'}
          </span>
        </div>
        <div className={st.Divider} />

        <div className={st.Row}>
          <span className={st.Label}>
            {t('card-page:info block.date created')}
          </span>
          <span className={st.Value}>
            {createdAt}
          </span>
        </div>
        <div className={st.Divider} />
        <div className={st.Row}>
          <span className={st.Label}>
            {t('card-page:info block.card id')}
          </span>
          <span className={st.Value}>
            <div className={st.CopyTextWrapper}>
              <Tooltip
                className={st.CopyText__Text}
                position="bottom"
                tooltipContent={cardId}
              >
                {cardId}
              </Tooltip>
              <div className={st.CopyText__Button}>
                <Tooltip
                  position="bottom"
                  tooltipContent={t('копировать')}
                >
                  <CopyButton value={cardId} />
                </Tooltip>
              </div>
            </div>
          </span>
        </div>
        <div className={st.Divider} />
      </div>
    </div>
  );
}
